<template>
  <aside
    class="relative h-screen flex flex-col transition-all duration-300 ease-in-out border-r border-white/10 shadow-xl"
    :class="[isCollapsed ? 'w-20' : 'w-64']"
    style="background-color: #0a0d26;"
  >


    <div class="h-20 flex items-center justify-center px-4 mb-4">
      <div class="border-b border-white/20 pb-2 w-full flex justify-center">
        <h1 v-if="!isCollapsed" class="text-2xl font-playfair font-semibold text-white tracking-wide">
          Naturel & Joli
        </h1>
        <h1 v-else class="text-xl font-playfair font-bold text-[#cd825b]">
          N&J
        </h1>
      </div>
    </div>

    <nav class="flex-1 px-3 space-y-8 overflow-y-auto custom-scrollbar">
      
      <div>
        <p v-if="!isCollapsed" class="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500 mb-4">
          Menu Principal
        </p>
        <div class="space-y-2">
          <RouterLink
            v-for="item in generalMenu"
            :key="item.label"
            :to="item.to"
            class="group flex items-center gap-3 rounded-xl px-4 py-3 transition-all duration-200"
            :class="[
              $route.path === item.to 
                ? 'bg-[#cd825b] text-white shadow-md shadow-[#cd825b]/20' 
                : 'text-gray-400 hover:bg-white/5 hover:text-white'
            ]"
          >
            <component :is="item.icon" class="w-5 h-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="text-sm font-medium tracking-wide leading-none transition-opacity duration-300">
              {{ item.label }}
            </span>
          </RouterLink>
        </div>
      </div>

      <div>
        <p v-if="!isCollapsed" class="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500 mb-4">
          Configuration
        </p>
        <div class="space-y-2">
          <RouterLink
            v-for="item in settingsMenu"
            :key="item.label"
            :to="item.to"
            class="group flex items-center gap-3 rounded-xl px-4 py-3 transition-all duration-200"
            :class="[
              $route.path === item.to 
                ? 'bg-[#cd825b] text-white shadow-md shadow-[#cd825b]/20' 
                : 'text-gray-400 hover:bg-white/5 hover:text-white'
            ]"
          >
            <component :is="item.icon" class="w-5 h-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="text-sm font-medium tracking-wide leading-none">
              {{ item.label }}
            </span>
          </RouterLink>
        </div>
      </div>
    </nav>

    <div class="mt-auto p-3 space-y-4 bg-black/20">
      <div 
        class="flex items-center gap-3 rounded-xl p-2 transition-colors duration-200"
        :class="[!isCollapsed ? 'bg-white/5' : 'justify-center']"
      >
        <img
          :src="user.photo"
          alt="Avatar"
          class="w-10 h-10 rounded-full object-cover ring-2 ring-[#cd825b]/30"
        />
        <div v-if="!isCollapsed" class="min-w-0">
          <p class="text-xs font-bold text-white truncate">
            {{ user.prenom }} {{ user.nom }}
          </p>
          <p class="text-[10px] text-gray-400 truncate">
            {{ user.email }}
          </p>
        </div>
      </div>

      <button
        @click="logout"
        class="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-all duration-200 group"
        :class="[isCollapsed ? 'justify-center' : '']"
      >
        <svg class="w-5 h-5 flex-shrink-0 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 11-4 0v-1m0-10V5a2 2 0 114 0v1" />
        </svg>
        <span v-if="!isCollapsed" class="text-sm font-bold tracking-wide">Déconnexion</span>
      </button>
    </div>
  </aside>
</template>

<script>
import { RouterLink } from "vue-router";
import DashboardIcon from "./Icons/DashboardIcon.vue";
import UserIcon from "./Icons/UserIcon.vue";
import FolderIcon from "./Icons/FolderIcon.vue";
import FileIcon from "./Icons/FileIcon.vue";
import GearIcon from "./Icons/GearIcon.vue";

export default {
  components: {
    RouterLink,
    DashboardIcon,
    UserIcon,
    FolderIcon,
    FileIcon,
    GearIcon,
  },

  data() {
    return {
      isCollapsed: false,
      user: this.getUserData(),
      generalMenu: [
        { label: "Dashboard", to: "/", icon: "DashboardIcon" },
        { label: "Calendrier", to: "/calendar", icon: "FolderIcon" },
        { label: "Clients", to: "/clients", icon: "UserIcon" },
        { label: "Catégories", to: "/catégorie", icon: "GearIcon" },
        { label: "Services", to: "/services", icon: "FileIcon" },
      ],
      settingsMenu: [
        { label: "Paramètres", to: "/parametre", icon: "GearIcon" },
      ],
    };
  },

  methods: {
    getUserData() {
      const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
      const prenom = storedUser.prenom || "Admin";
      const nom = storedUser.nom || "";
      return {
        nom,
        prenom,
        email: storedUser.email || "contact@natureletjoli.fr",
        photo: storedUser.photo || `https://ui-avatars.com/api/?name=${prenom}+${nom}&background=cd825b&color=fff`,
      };
    },
    logout() {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("user");
      window.location.href = "/login";
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&display=swap');

.font-playfair {
  font-family: 'Playfair Display', serif;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

/* Animation de transition douce pour le texte */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>